// ==============================|| OVERRIDES - DATA GRID ||============================== //
import { gridClasses } from '@mui/x-data-grid';
import { alpha } from '@mui/material/styles';
import colors from 'assets/theme-dark/base/colors';
import borders from 'assets/theme-dark/base/borders';

const { white, grey, gradients, black } = colors;
const { primary } = gradients;
const ODD_OPACITY = 0.2;
const selectedOpacity = 0.3;
const hoverOpacity = 0.2;
const { borderWidth, borderColor } = borders;

const DataGrid = {
  styleOverrides: {
    root: {
      [`& .${gridClasses.row}.even`]: {
        backgroundColor: grey[200],
        '&:hover, &.Mui-hovered': {
          backgroundColor: alpha(primary.main, ODD_OPACITY),
          '@media (hover: none)': {
            backgroundColor: 'transparent',
          },
        },
        '&.Mui-selected': {
          backgroundColor: alpha(primary.main, ODD_OPACITY + selectedOpacity),
          '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(
              primary.main,
              ODD_OPACITY + selectedOpacity + hoverOpacity
            ),
            '@media (hover: none)': {
              backgroundColor: alpha(
                primary.main,
                ODD_OPACITY + selectedOpacity
              ),
            },
          },
        },
      },
      '&:hover': {
        color: black.main,
        backgroundColor: white.main,
      },
    },
    columnHeader: {
      padding: 'unset',
      backgroundColor: grey[600],
    },
    pinnedColumnHeaders: {
      padding: '0px 6px 0px 6px',
      backgroundColor: grey[600],
      borderTopLeftRadius: 'unset',
      borderTopRightRadius: 'unset',
    },
    columnHeaders: {
      padding: '0px 6px 0px 6px',
      backgroundColor: grey[600],
      borderTopLeftRadius: 'unset',
      borderTopRightRadius: 'unset',
      '& .MuiDataGrid-pinnedColumnHeaders': {
        padding: '0px 6px 0px 6px',
        backgroundColor: grey[600],
        borderTopLeftRadius: 'unset',
        borderTopRightRadius: 'unset',
      },
    },

    columnHeaderTitle: {
      fontSize: '15px',
      whiteSpace: 'normal',
      lineHeight: '20px',
      color: white.main,
    },
    row: {
      background: white.main,
    },
    cell: {
      padding: '0px 5px',
      borderRight: `${borderWidth[1]} solid ${borderColor}`,
    },
    cellContent: {
      fontSize: '15px',
      whiteSpace: 'normal',
      lineHeight: '18px',
      padding: '15px 0px',
    },
    iconButtonContainer: {
      width: 'unset',
    },
    iconSeparator: {
      display: 'none',
    },
    footerContainer: {
      backgroundColor: '#D3D3D3',
      height: '44px',
      minHeight: 'unset',
    },
  },
};

export default DataGrid;
